/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_EyebrowInputs */

const es_l7_law_eyebrow = /** @type {(inputs: L7_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por fin es legal`)
};

const gl_l7_law_eyebrow = /** @type {(inputs: L7_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por fin é legal`)
};

const en_l7_law_eyebrow = /** @type {(inputs: L7_Law_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finally legal`)
};

/**
* | output |
* | --- |
* | "Finally legal" |
*
* @param {L7_Law_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_eyebrow = /** @type {((inputs?: L7_Law_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_eyebrow(inputs)
	if (locale === "en") return en_l7_law_eyebrow(inputs)
	return es_l7_law_eyebrow(inputs)
});